import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails,
  TotalDriversResponseDTO
} from '../../interfaces/apiInterfaces';

export class GetTotalOwnerDriversCommand extends IRequestCommand<
  IGetTotalOwnerDriversResponse,
  ErrorDetails,
  IGetTotalOwnerDriversCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierUserId}/drivers/owner/{ownerId}/totalDrivers?driverId={driverId}';
  public override setParameters(parameters: IGetTotalOwnerDriversCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId
    );
    this._commandUrl = this._commandUrl.replace(
      '{ownerId}',
      parameters.ownerId
    );
    this._commandUrl = this._commandUrl.replace(
      '{driverId}',
      parameters.driverId ? parameters.driverId : ''
    );
  }
}

export interface IGetTotalOwnerDriversCommandParameters extends ICommandParameters {
  carrierUserId: string;
  ownerId: string;
  driverId: string;
}

export interface IGetTotalOwnerDriversResponse
  extends TotalDriversResponseDTO,
  ICommandResponse { }
